module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("contents")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_FM2"
    }
  }, [_c('b', [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Frank Bures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction"
    }
  }, [_c('b', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Laurie Hertzel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01"
    }
  }, [_c('b', [_vm._v("Little House with the Shared Wall")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Kao Kalia Yang")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter02"
    }
  }, [_c('b', [_vm._v("Counting Swallows")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Morgan Grayce Willow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03"
    }
  }, [_c('b', [_vm._v("The City by Segway")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Doug Mack")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Distortion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Todd Boss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Sewers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Bill Donahue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Minneapolis Poem")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("James Wright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Minneapolis Poem")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Dobby Gibson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("No, You Turn")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Jason Good")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Safe in Minnesota")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Ahmed Ismail Yusuf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Revealing Season")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Marlon James")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Prince is Alive! (And Lives in Minneapolis)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Neal Karlen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Bobby Zimmerman Was Here")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Leif Pettersen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Rock ’n’ Roll Exterminators")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Eric Dregni")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Spark")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Valérie Déus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Wild Places")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Kelly Barnhill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("On Minnehaha Creek in May")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Kris Bigalk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Run for Me")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Lindsay Nielsen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("My Brother’s Bachelor Party")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Kevin Kling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Coldest Game")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Steve Marsh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Elegy for the Metrodome")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Matt Rasmussen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Mauer Myth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Robert O’Connell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Cycling Season")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("William Souder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Secret Handshake")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Max Ross")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Minneapolis, revisited")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Shannon Gibney")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("You Tell Me")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Sofia Burford")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Minneapolis Public")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("David Mura")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Parkway Theater, 1969")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Sheila O’Connor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Powderhorn")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Ed Bok Lee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Long Road from Somalia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Fathia Absie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Dakota Homecoming")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Gwen Nell Westerman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Over There")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Sarah Stonich")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Full Circle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Marge Barrett")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Seasons of Minneapolis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Adam Regn Arvidson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Why")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Bao Phi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Invisible Ink: The Art of an Unfinished Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Jason Albert")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The First Winter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Rae Meadows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Chain of Lakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Jay Botten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Life on an Urban Lake")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("John Rosengren")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("On The Number 6 between Lakewood Cemetery and Lake Calhoun")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Julian Bernick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Crossing Over")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Megan Kaplan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Hennepin and Lagoon, Minneapolis, 1984")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Joshua Davies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Wall of Sound")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Lars Ostrom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Purple Rain")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Luisa Muradyan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Homeboy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("J. D. Fratzke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53_Chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Lake Street Teppanyaki Grill and Supreme Buffet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Marcie Rendon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54_Chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Eating Halva on Lake Street")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("James Norton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55_Chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Beauty Supply")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Dobby Gibson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/56_Chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Party Bus")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Peggy “Pearl” Zambory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/57_Chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("On 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Street Northeast")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Francine Marie Tolf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/58_Chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Forgotten River")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Jonathan Raban")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/59_Chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Draw of the River: John Berryman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Sandra Sidman Larson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/60_Chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Mississippi Drift")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Matthew Power")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/61_Chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Elegy for Bridge 9340, "), _c('i', [_vm._v("Minneapolis, 2007")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Su Hwang")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/62_Chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Nye’s")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Julia Klatt Singer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63_Chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Midnight in the Garden with Claes Oldenburg")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Tami Mohamed Brown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/64_Chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Prince of the Midwest")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Michael Perry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/65_Chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("I’m Going Back to Minnesota Where Sadness Makes Sense")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Danez Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/66_Contributors",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/67_Acknowledgement",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Acknowledgements")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2298b851","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Contents.vue
// module id = 72
// module chunks = 0